import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/package-grey.svg'
import _imports_1 from '@/assets/img/icon/return-box-white.png'
import _imports_2 from '@/assets/img/icon/scan-white.png'


const _hoisted_1 = { class: "card-ready-delivery-v2" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "container-icon mb-3 pr-5" }
const _hoisted_4 = {
  key: 0,
  class: "background-blue-grey-lighten-5 rounded-full"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "p-3",
  style: {"width":"24px'"}
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "relative"
}
const _hoisted_7 = {
  key: 0,
  class: "flex items-center rounded-full background-primary absolute p-1",
  style: {"left":"0","top":"0"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-2 h-2"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: "#E8F5E9"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M28.5 21.4L19.5 16.21",
    stroke: "#4CAF50",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M33 27.9999V19.9999C32.9996 19.6492 32.9071 19.3047 32.7315 19.0011C32.556 18.6974 32.3037 18.4453 32 18.2699L25 14.2699C24.696 14.0944 24.3511 14.002 24 14.002C23.6489 14.002 23.304 14.0944 23 14.2699L16 18.2699C15.6963 18.4453 15.444 18.6974 15.2685 19.0011C15.0929 19.3047 15.0004 19.6492 15 19.9999V27.9999C15.0004 28.3506 15.0929 28.6951 15.2685 28.9987C15.444 29.3024 15.6963 29.5545 16 29.7299L23 33.7299C23.304 33.9054 23.6489 33.9979 24 33.9979C24.3511 33.9979 24.696 33.9054 25 33.7299L32 29.7299C32.3037 29.5545 32.556 29.3024 32.7315 28.9987C32.9071 28.6951 32.9996 28.3506 33 27.9999Z",
    stroke: "#4CAF50",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M15.2695 18.96L23.9995 24.01L32.7295 18.96",
    stroke: "#4CAF50",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M24 34.08V24",
    stroke: "#4CAF50",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_10 = { class: "max-w-sm col-span-3" }
const _hoisted_11 = { class: "text-black font-semibold break-words" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "color-blue-grey text-sm flex" }
const _hoisted_14 = { class: "list-disc" }
const _hoisted_15 = {
  class: "",
  style: {"list-style-type":"none"}
}
const _hoisted_16 = { class: "color-blue-grey text-sm" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_18 = { class: "ml-3 color-blue-grey text-sm" }
const _hoisted_19 = { class: "color-blue-grey text-sm" }
const _hoisted_20 = { class: "color-blue-grey text-sm" }
const _hoisted_21 = { class: "max-w-sm col-span-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Alamat Tujuan", -1)
const _hoisted_23 = { class: "text-black font-semibold text-sm break-words" }
const _hoisted_24 = { class: "max-w-sm col-span-1" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Status", -1)
const _hoisted_26 = { class: "col-span-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-xs" }, "Kurir Pengantar", -1)
const _hoisted_29 = { class: "flex gap-2 items-center min-w-full pl-2" }
const _hoisted_30 = {
  key: 0,
  class: "background-green rounded-full flex items-center p-2"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M9 1L3.5 6.5L1 4",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_32 = {
  key: 1,
  class: "rounded-full flex items-center p-2",
  style: {"background":"#FF5F5F"}
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_34 = { class: "font-bold cursor-pointer" }
const _hoisted_35 = { class: "flex gap-2 items-center w-full" }
const _hoisted_36 = { class: "font-bold cursor-pointer" }
const _hoisted_37 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_38 = {
  key: 0,
  class: "flex items-center mr-2 z-10"
}
const _hoisted_39 = { class: "flex w-full items-center justify-center" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-white" }, "Konf. Pengembalian Paket", -1)
const _hoisted_42 = { class: "pt-4 pb-2" }
const _hoisted_43 = { class: "font-bold cursor-pointer hover-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_SelectAsync = _resolveComponent("SelectAsync")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_VirtualScroll = _resolveComponent("VirtualScroll")

  return (_openBlock(), _createBlock("article", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.isUseScheduleBtn)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (_ctx.useSelectQourier)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              (_ctx.data?.DeliveryStatusId === 12)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true),
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        class: ["card-content pb-3 grid grid-cols-9 gap-4 items-center", _ctx.data.IsCheck ? 'border-bottom-primary' : 'border-bottom-blue-grey-lighten-4']
      }, [
        _createVNode("div", _hoisted_10, [
          _createVNode("p", _hoisted_11, _toDisplayString(_ctx.data?.DeliveryWaybill), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("ul", _hoisted_14, [
                _createVNode("li", _hoisted_15, _toDisplayString(_ctx.data?.DeliveryGoodsCategory), 1)
              ])
            ]),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_16, "Jumlah Koli : " + _toDisplayString(_ctx.data?.DeliveryTotalKoli), 1),
              _hoisted_17,
              _createVNode("span", _hoisted_18, "Total Berat : " + _toDisplayString(_ctx.data?.DeliveryTotalWeight), 1)
            ]),
            _createVNode("p", _hoisted_19, "Tgl Keberangkatan : " + _toDisplayString(_ctx.data?.DeliveryDepartureSchedule ?
              _ctx.moment(_ctx.data.DeliveryDepartureSchedule).format('DD MMMM YYYY') : '-'), 1),
            _createVNode("p", _hoisted_20, "Isi Menurut Pengakuan : " + _toDisplayString(_ctx.data.DeliveryAdditionalCostNote), 1)
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("p", _hoisted_23, _toDisplayString(_ctx.data?.DeliveryRecipientAddress), 1)
        ]),
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_Button, {
            class: "p-button-sm rounded-md p-button-outlined cursor-default mt-2 mr-3 w-full md:w-auto md:mt-0",
            style: { backgroundColor: _ctx.data.DeliveryStatusAttribute1, border: `1px solid ${_ctx.data.DeliveryStatusAttribute2}` }
          }, {
            default: _withCtx(() => [
              _createVNode("p", {
                class: "font-semibold text-sm break-words",
                style: { color: _ctx.data.DeliveryStatusAttribute2 }
              }, _toDisplayString(_ctx.data.DeliveryStatusName), 5)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _createVNode("div", _hoisted_26, [
          (_ctx.useSelectQourier)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_SelectAsync, _mergeProps({
                  idInput: `card-deliver-list-courier-${_ctx.index}`,
                  class: "input-primary no-box-shadow no-border cursor-pointer can-not-empty"
                }, _ctx.paramCourierAssign, {
                  modelValue: _ctx.data.Courier,
                  "onUpdate:modelValue": _ctx.onChangeCourier,
                  disabled: (_ctx.data.CourierId && _ctx.route?.meta?.permission?.update === true) ? true : false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickSelect($event)))
                }), {
                  singlelabel: _withCtx(({ value: valSelect }) => [
                    _createVNode("div", _hoisted_29, [
                      (_ctx.data.IsActive === true)
                        ? (_openBlock(), _createBlock("div", _hoisted_30, [
                            _hoisted_31
                          ]))
                        : (_ctx.data.IsActive === false && valSelect)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, [
                              _hoisted_33
                            ]))
                          : (valSelect.Picture)
                            ? (_openBlock(), _createBlock("img", {
                                key: 2,
                                src: `${_ctx.API_BASE}${valSelect.Picture}`,
                                class: "rounded-full object-cover w-8 h-8"
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createBlock(_component_Avatar, {
                                key: 3,
                                label: valSelect.Fullname.charAt(0),
                                shape: "circle"
                              }, null, 8, ["label"])),
                      _createVNode("p", _hoisted_34, _toDisplayString(valSelect.label), 1)
                    ])
                  ]),
                  option: _withCtx(({ option }) => [
                    _createVNode("div", _hoisted_35, [
                      (option.Picture)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: `${_ctx.API_BASE}${option.Picture}`,
                            class: "rounded-full object-cover w-8 h-8"
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_Avatar, {
                            key: 1,
                            label: option.Fullname.charAt(0),
                            shape: "circle"
                          }, null, 8, ["label"])),
                      _createVNode("p", _hoisted_36, _toDisplayString(option.Fullname), 1)
                    ])
                  ]),
                  _: 1
                }, 16, ["idInput", "modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.useSelectQourier)
          ? (_openBlock(), _createBlock("div", _hoisted_37, [
              (_ctx.route?.meta?.permission?.update && !(_ctx.data.DeliveryStatusCode === 'MKK'))
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    (!_ctx.data.IsCheck && _ctx.data.IsActive)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: "pi pi-ellipsis-v color-blue-grey cursor-pointer",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDropDown($event)))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_39, [
                (_ctx.data.DeliveryStatusCode === 'MKK')
                  ? (_openBlock(), _createBlock("div", _hoisted_40, [
                      _createVNode(_component_Button, {
                        class: "btn-primary p-button-sm",
                        onClick: _ctx.onConfirmPackageReturn
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createBlock(_component_Checkbox, {
                      key: 1,
                      binary: true,
                      modelValue: _ctx.data.IsCheck,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.IsCheck = $event)),
                      class: "checkbox-primary",
                      disabled: !_ctx.route?.meta?.permission?.write
                    }, null, 8, ["modelValue", "disabled"]))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_OverlayPanel, { ref: "refOp" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          packageReturn: _ctx.route?.meta?.permission?.update,
          changeCourier: _ctx.route?.meta?.permission?.update,
          onPackageReturn: _ctx.onPackageReturn,
          onChangeCourier: _ctx.onTransferCourier
        }, null, 8, ["packageReturn", "changeCourier", "onPackageReturn", "onChangeCourier"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, { ref: "refPanelListCourier" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_42, [
          _createVNode(_component_VirtualScroll, _mergeProps(_ctx.paramListCourier, {
            style: {"max-height":"8rem"},
            class: "px-4 overflow-y-auto small-scroll-y "
          }), {
            default: _withCtx(({ items: courierOptions }) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(courierOptions, (option, key) => {
                return (_openBlock(), _createBlock("div", {
                  class: "flex gap-2 items-center w-full mb-2",
                  onClick: ($event: any) => (_ctx.selectCourier(option)),
                  key: key
                }, [
                  (option.Picture)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: `${_ctx.API_BASE}${option.Picture}`,
                        class: "rounded-full object-cover w-8 h-8"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_Avatar, {
                        key: 1,
                        label: option.Fullname?.charAt(0),
                        shape: "circle"
                      }, null, 8, ["label"])),
                  _createVNode("p", _hoisted_43, _toDisplayString(option.Fullname), 1)
                ], 8, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 16)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}